<template>
  <section class="process" id="process">
    <process-clouds></process-clouds>
    <custom-title text="Philosophy" header-class="process-title" text-colour="white" stripe-colour="#C0BDD6"></custom-title>
    <p>
      Unicorn Global came about out of frustration with the way most current agencies and companies operate.
      Our philosophy? <b>If you don’t like the way something works, change it!</b>
    </p>
    <!--  -->
    <!-- <p> -->
    <!--   We have discarded almost every traditional way of working that you can think of. Office hours? With a <b>globally -->
    <!--   distributed team</b> these remain where they should be – in the past. -->
    <!-- </p> -->
    <!-- <p> -->
    <!--   No meetings mean less talking and more doing. -->
    <!--   Everyone works autonomously and is in constant communication with one another. -->
    <!--   Slack is our office and because our team spans time zones from GMT+8 to GMT-5 there is always someone available. -->
    <!--   This working style lends itself to <b>increased levels of collaboration, high availability, improved quality, -->
    <!--   and rapid throughput.</b> -->
    <!-- </p> -->
    <p>
      With a <b>focus on quality and robustness</b>, everything in our stable, from our working style to what we create
      has been developed with continual optimisation in mind, and we are always questioning and refining our
      processes and techniques.
    </p>
    <process-slider :cards="cards"></process-slider>
  </section>
</template>

<style scoped>
.process {
  background: #272460;
  color: #D0CFDD;
  width: 100%;
  padding-bottom: 3em;
}

p {
  color: #C6C5D6;
  margin: 2rem auto;
  max-width: 80%;
  width: 600px;
  font-size: 1.1rem;
  text-align: left;
}
</style>

<script>
import CustomTitle from './CustomTitle'
import ProcessClouds from './ProcessClouds'
import ProcessSlider from './ProcessSlider/ProcessSlider'

export default {
  components: {
    ProcessClouds,
    ProcessSlider,
    CustomTitle
  },
  data () {
    return {
      cards: [
        {
          icon: require('../assets/hours.svg'),
          title: 'No Office Hours',
          body: 'With a globally distributed team these remain where they should be – in the past.'
        },

        {
          icon: require('../assets/slack.svg'),
          title: 'Slack',
          body: 'Slack is our office and because our team spans time zones from GMT+8 to GMT-5 there is always someone available'
        },

        {
          icon: require('../assets/collaboration.svg'),
          title: 'Collaboration',
          body: 'Our working style lends itself to high levels of collaboration.'
        },
        {
          icon: require('../assets/robotic.svg'),
          title: 'Automation',
          body: 'We automate as much as possible so that we don\'t waste time on repetitive tasks.'
        },
        {
          icon: require('../assets/laboratory.svg'),
          title: 'Creation',
          body: 'High quality hand crafted globally sourced code.'
        }
      ]
    }
  }
}
</script>
